<div class="row">
  <div class="col-12 py-5">
    <h4>Locations</h4>
  </div>
</div>

<div class="row">
  <div *ngFor="let location of locations" class="col-md-4 col-sm-6 col6 equel-grid">
    <div class="grid device-card">
      <div class="grid-body text-gray">
        <div class="split-header">
          <div>
            <p class="card-title">{{location.company}}</p>
            <p class="text-muted">{{location.city}}, {{location.prov}}</p>
          </div>
          <a class="btn action-btn btn-cs component-flat" routerLink="{{location.id}}">
            <i class="mdi mdi-lead-pencil"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
